export const PROFILE_NUMBER = {
  ADMINISTRATOR: 1,
  CONSULTATION: 2,
  REPORTS: 3,
  MODIFICATION: 4,
} as const;

export const PROFILE_NAME: Readonly<Record<number, string>> = {
  [PROFILE_NUMBER.ADMINISTRATOR]: 'Administrador',
  [PROFILE_NUMBER.CONSULTATION]: 'Consulta',
  [PROFILE_NUMBER.REPORTS]: 'Reportes',
  [PROFILE_NUMBER.MODIFICATION]: 'Modificación',
};
